import React from 'react';
import { render } from 'react-dom';

import { errorCodes, getErrorMessageKey } from '../../util/errorCodes';
import jsonGet from '../../util/jsonGet';

import BookingStopoverOptions from '../react/BookingStopoverOptions';
import ErrorMessage from '../react/Core/ErrorMessage';
import Loading from '../react/Core/Loading';
import ProgressBar from '../react/ProgressBar';

export default class BookingStopoverOptionsRender {
  constructor(context) {
    this.context = context;
    this.init();
  }

  init() {
    const { apiUrl, model, currentProgressBarStep, loadApi, title } = this.context.dataset;

    if (!apiUrl || !model || !loadApi || !currentProgressBarStep)
      throw Error('Missing a required dataset');

    let labels;
    try {
      labels = JSON.parse(model);
    } catch (e) {
      labels = undefined;
      console.error('Error parsing labels json: ', model);
    }

    const urlSearchParams = new URLSearchParams(window.location.search);
    const orderId = urlSearchParams.get('OrderId') || urlSearchParams.get('orderId');
    const loadApiUrl = `${loadApi}/${orderId}`;

    jsonGet(loadApiUrl, null, (response) => {
      if (response.errorCode) {
        if (response.errorCode === errorCodes.TourBookingTourHasReachedPaxCapLimit) {
          window.location.href = response.redirectUri;
        }
        const errorMessageKey = getErrorMessageKey(response.errorCode);
        return render(
          <ErrorMessage text={labels[errorMessageKey] || response.message} />,
          this.context
        );
      }

      return render(
        BookingStopoverOptionsRender.renderMain(
          response,
          labels,
          apiUrl,
          title,
          currentProgressBarStep,
          orderId
        ),
        this.context
      );
    });

    return render(
      BookingStopoverOptionsRender.renderMain(
        undefined,
        labels,
        apiUrl,
        title,
        currentProgressBarStep,
        orderId
      ),
      this.context
    );
  }

  static renderMain(travelOptionsLoadData, labels, apiUrl, title, selectedStep, orderId) {
    return (
      <>
        <ProgressBar
          steps={travelOptionsLoadData?.progressBarSteps}
          selectedStep={selectedStep}
          orderId={orderId}
        />
        <div className="PageTitle">
          <h1 className="PageTitle_title">{title}</h1>
        </div>
        {travelOptionsLoadData ? (
          <BookingStopoverOptions
            package={travelOptionsLoadData}
            labels={labels}
            apiURL={apiUrl}
            selectedStep={selectedStep}
            orderId={orderId}
          />
        ) : (
          <Loading />
        )}
      </>
    );
  }
}
